import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[580px] md:min-h-[680px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Elevated%20aerial%20flat%20lay%20photography%20of%20curated%20fashion%20and%20lifestyle%20items%20including%20a%20premium%20leather%20sneaker%20cashmere%20scarf%20and%20minimalist%20accessories%20arranged%20in%20an%20organic%20scattered%20composition%20on%20warm%20toned%20textured%20linen%20fabric%20with%20soft%20golden%20hour%20window%20light%20casting%20long%20elegant%20shadows%20sophisticated%20editorial%20aesthetic%20with%20subtle%20warmth%20and%20depth&width=1800&height=1200&seq=hero-bg-v2&orientation=landscape"
          alt="OOPBuy Spreadsheet Produkte Übersicht"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/30"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center pt-16">
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-4 md:mb-6 leading-tight">
          OOPBuy Spreadsheet – Finde die besten Produkte schneller
        </h1>
        <p className="text-base md:text-lg text-white/85 max-w-2xl mx-auto mb-8 md:mb-10 leading-relaxed">
          Die deutsche Plattform für OOPBuy Spreadsheet Übersichten, Produktkategorien, Vergleiche und hilfreiche Einkaufs-Guides.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4 mb-10">
          <Link
            to="/artikel/oopbuy-spreadsheet-guide"
            className="px-6 py-3 text-sm font-medium bg-white text-foreground-900 rounded-full hover:bg-background-100 transition-all whitespace-nowrap cursor-pointer"
          >
            Zum OOPBuy Spreadsheet Guide
          </Link>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="px-6 py-3 text-sm font-medium bg-accent-500 text-white rounded-full hover:bg-accent-600 transition-all whitespace-nowrap cursor-pointer flex items-center gap-2"
          >
            buy it now
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-4 md:gap-6 text-white/80 text-xs md:text-sm">
          <span className="flex items-center gap-1.5">
            <i className="ri-check-line text-accent-400"></i>
            Deutsche Guides
          </span>
          <span className="flex items-center gap-1.5">
            <i className="ri-check-line text-accent-400"></i>
            Strukturierte Kategorien
          </span>
          <span className="flex items-center gap-1.5">
            <i className="ri-check-line text-accent-400"></i>
            Aktualisierte Informationen
          </span>
          <span className="flex items-center gap-1.5">
            <i className="ri-check-line text-accent-400"></i>
            Sicherheitsorientierte Nutzung
          </span>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-s-line text-white/60 text-2xl"></i>
      </div>
    </section>
  );
}